import { render, staticRenderFns } from "./advancedSetup.vue?vue&type=template&id=3afe05aa&scoped=true&"
import script from "./advancedSetup.vue?vue&type=script&lang=js&"
export * from "./advancedSetup.vue?vue&type=script&lang=js&"
import style0 from "./advancedSetup.vue?vue&type=style&index=0&id=3afe05aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe05aa",
  null
  
)

export default component.exports